import { QRCodeSVG } from "qrcode.react";
import tokens from "@/theme/tokens";

export const ScanToBook = ({ className = "", testId = "scan-to-book" }) => (
  <div data-testid={testId} className={`glass flex items-center gap-4 rounded-2xl p-3 pr-5 ${className}`}>
    <div className="rounded-xl bg-ivory p-2">
      <QRCodeSVG value={`${window.location.origin}/book`} size={84} fgColor={tokens.colors.ink} bgColor={tokens.colors.ivory} data-testid={`${testId}-qr`} />
    </div>
    <div className="leading-tight">
      <p className="eyebrow text-gold">Scan to book</p>
      <p className="mt-1 max-w-[9rem] text-xs text-mist">Open booking on your phone in one scan.</p>
    </div>
  </div>
);
